app.ui.addFeature(
	'subForm',
	function(){
		'use strict';

		var self = this,
			html = '';

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the component
		*/
		self.init = function(){
			var def = app.deferred();

			def.step(
				function(){
					app.templates.get('html/subForm-entry').finished(def.next);
				}
			);

			def.step(
				function(res){
					html = res;
					def.next();
				}
			);

			return def.begin();
		};

		/*
			Name: render
			Use: API.render()
			Args: subForm Object - Subform configuration
			Description: Renders a sub form on a data entry screen
		*/
		self.render = function(subForm, renderedFormControl){
			/*
				NOTE:
					Save listeners are applied after HTML is compiled so return this to be executed later
			*/
			var saveListener = (
				function(){
					$('#add-' + subForm.formID).on(
						'click',
						function(){
							renderedFormControl.dataEntryApp.subForms[subForm.id].savedValues.push(
								JSON.clone(renderedFormControl.dataEntryApp.subForms[subForm.id].fieldValues)
							);

							subForm.fields.forEach(
								function(field){
									if(field == null){
										return;
									}
									if(field.type === 'checkbox'){
										renderedFormControl.dataEntryApp.subForms[subForm.id].fieldValues[field.properties.id] = [];
									}
									else {
										renderedFormControl.dataEntryApp.subForms[subForm.id].fieldValues[field.properties.id] = '';
									}

									if(field.default){
										renderedFormControl.dataEntryApp.subForms[subForm.id].fieldValues[field.properties.id] = field.default.compile(
											{
												now: moment().format('MM/DD/YYYY')
											}
										);
									}
								}
							);
						}
					);
				}
			);

			return {
				html : html.compile(
					{
						subForm : subForm,
						helpers : {
							renderField : function(field){
								return (app.ui.fieldController[field.type] || app.ui.fieldController['default'])(field);
							},
							renderInfoBox : function(){
								return app.ui.fieldController.infobox(
									{
										default : subForm.instructions
									}
								);
							},
							getDefaultDisplay : function(){
								return setupConditions(subForm, renderedFormControl);
							}
						}
					}
				),
				saveListener : saveListener
			};
		};

		/*
			Name: setupConditions
			Use: PRIVATE.setupConditions()
			Args: subForm Object - The specific sub form having the conditions applied to
					renderedFormControl Object - Full configuration for this data entry screen
			Description: Applies conditional logic to sub forms
		*/
		function setupConditions(subForm, renderedFormControl){
			var defaultDisplay = '';

			if(subForm.settings.conditions && subForm.settings.conditions.length > 0){
				subForm.settings.conditions.forEach(
					(con) => {
						if(con.condition === 'show'){
							defaultDisplay = 'display: none;';
							renderedFormControl.vueWatchers['fieldValues.' + con.field] = function(){
								if(
									renderedFormControl.dataEntryApp.fieldValues[con.field] === con.value
									||
									(renderedFormControl.dataEntryApp.fieldValues[con.field] === 'NO' && con.value === false)
									||
									(renderedFormControl.dataEntryApp.fieldValues[con.field] === 'YES' && con.value === true)
								){
									$('#subform-' + subForm.formID).css('display','block');
								}
								else {
									$('#subform-' + subForm.formID).css('display','none');
								}
							}
						}
					}
				);
			}

			return defaultDisplay;
		}

		return self
	}
);
